// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2DqRK","info":"UpdateTermsInfo_info__2gX9S"};